import './ItemCard.css';
import { Active } from '../Icons/Active'
import { Inactive } from '../Icons/Inactive'
import config from '../../../../../../config/config';

export const ItemCard = ({ isActive, title, description, onClick, imageURL, imageUF }) => {
  return (
    <div
      className="entity-projects-card"
      onClick={onClick}
      style={{ backgroundImage: `url(${imageURL ? `${config.endpoints.backend}${imageURL}` : '/image/notfound.png'})` }}
    >
      <div className='entity-projects-textbox'>
        <div>
          {isActive == 1 ? <Active /> : <Inactive />}
        </div>
        <p className='entity-projects-text'>
          {imageUF && <img className='entity-projects-text-image' src={imageUF} alt="UF" />} {title}
        </p>
        <p className='entity-projects-description'>
          {description}
        </p>
      </div>
    </div>
  )
}
